var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZeroStateBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 20,
    y: 20,
    width: 30,
    height: 30,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.0%",
    y: "-3.3%",
    width: "113.3%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43,39.3333333 L43,40 L40.3333333,40 L40.3333333,39.3333333 L40.89,39.3333333 C41.062,39.3333333 41.16,39.2146667 41.104,39.052 L40.7886667,38.138 L39.3013333,38.138 L38.918,37.078 L40.448,37.078 L39.54,34.36 L38.7706667,36.6606667 L38.1846667,34.9953333 L38.7986667,33.3333333 L40.28,33.3333333 L42.302,39.0106667 C42.376,39.2206667 42.4646667,39.3333333 42.6873333,39.3333333 L43,39.3333333 Z M39,38.6666667 L39.6666667,38.6666667 L39.6666667,40 L35,40 L35,38.6666667 L35.3546667,38.6666667 C35.6606667,38.6666667 35.876,38.3646667 35.7766667,38.0753333 L35.2326667,36.6666667 L31.078,36.6666667 L30.5346667,38.0753333 C30.4353333,38.3646667 30.6506667,38.6666667 30.9566667,38.6666667 L31.6666667,38.6666667 L31.6666667,40 L27,40 L27,38.6666667 L27.2866667,38.6666667 C27.682,38.6666667 28.0353333,38.4166667 28.1666667,38.0433333 L31.838,28 L34.4726667,28 L38.144,38.0433333 C38.2753333,38.4166667 38.604,38.6666667 39,38.6666667 Z M31.7426667,34.6666667 L34.568,34.6666667 L33.062,30.534 L31.7426667,34.6666667 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.2%",
    y: "-33.3%",
    width: "162.5%",
    height: "183.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-345.000000, -1350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-zero-state-blog",
    transform: "translate(345.000000, 1350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-blog"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#84DCC6",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    rx: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "square",
    fillOpacity: 0.100000001,
    fill: "#000000",
    fillRule: "evenodd",
    x: 21,
    y: 21,
    width: 28,
    height: 28,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZeroStateBlog);
export default __webpack_public_path__ + "static/media/icon-zero-state-blog.653bd1010cab29d042dccc503fce85eb.svg";
export { ForwardRef as ReactComponent };